import * as React from 'react';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router';

function Dashboard() {
  const dashboard= useSelector(state => state.dashboard)
  
  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar />
      <Sidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, px:4.4  ,mt:{md:6,xs:4} , width: {
          xs: '100%',
          lg: `calc(100% - ${dashboard.drawerWidth}px)` 
        } }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}



export default Dashboard;
